import { DZ_COLOR_YELLOW_400 } from '@blk/daisy/core/styles';
import { AbstractRenderer, Alignment, BusinessComponent, BusinessComponentOptions, ColumnPanel, RowPanel, SquareRenderer, StaticParagraphComponent } from '@blk/simba';
import { SlugifyPipe } from '@ddt-web/generic-utils';
import { HeadingComponent, HeadingLevel } from '@ddt-web/pdf-components';

export class ModelOverview extends BusinessComponent {

	constructor(
		name: string,
		public aladdinTicker: string,
		public familyOverview: string,
		public tradeFrequency: string,
		public investmentVehicle: string,
		public modelBenchmarkDisclaimer: string | undefined = undefined,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible }));
	}

	public buildComponent(): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		panels.push(
			new RowPanel('Model Overview Heading', [new HeadingComponent('MODEL_OVERVIEW_HEADER', 'MODEL OVERVIEW', HeadingLevel.H1)],
				{ marginBottom: 32 },
				Alignment.Horizontal.Left,
				Alignment.Vertical.Top),

			this.buildBodySection()

		);
		return panels;
	}

	private buildBodySection(): RowPanel {

		const panel: RowPanel = new RowPanel('Model Overview Body', [
			new ColumnPanel('Overview Left Section', [
				new RowPanel(`Model Overview -  Objective}`, [
					this.getHeaderSquare(),
					new ColumnPanel('Objective Data', [
						new StaticParagraphComponent('PDF_OBJECTIVE_HEADER',
							'Objective', {}, { marginBottom: 8 }, ['text-extra-bold', 'text-16']),
						new StaticParagraphComponent(`PDF_OBJECTIVE_${this.getSlugifiedText(this.aladdinTicker)}`,
							this.familyOverview, {}, {}, ['text-9'])
					], {}, Alignment.Horizontal.Left, Alignment.Vertical.Top)
				], { marginBottom: 34 }, Alignment.Horizontal.Left),
				new RowPanel(`Model Overview -  Trade Frequency}`, [
					this.getHeaderSquare(),
					new ColumnPanel('Trade Frequency Data', [
						new StaticParagraphComponent('PDF_TRADE_FREQUENCY_HEADER',
							'Trade Frequency', {}, { marginBottom: 8 }, ['text-extra-bold', 'text-16']),
						new StaticParagraphComponent(`PDF_TRADE_FREQUENCY_${this.getSlugifiedText(this.tradeFrequency)}`,
							this.tradeFrequency, {}, {}, ['text-9'])
					], {}, Alignment.Horizontal.Left)
				], { marginBottom: 34 }, Alignment.Horizontal.Left),
				new RowPanel(`Model Overview -  Vehicle}`, [
					this.getHeaderSquare(),
					new ColumnPanel('Vehicle Data', [
						new StaticParagraphComponent('PDF_INVESTMENT_VEHICLE_HEADER',
							'Underlying Investment Vehicle(s)', {}, { marginBottom: 8 }, ['text-extra-bold', 'text-16']),
						new StaticParagraphComponent(`PDF_INVESTMENT_VEHICLE_${this.getSlugifiedText(this.investmentVehicle)}`,
							this.investmentVehicle, {}, {}, ['text-9'])
					], {}, Alignment.Horizontal.Left)
				], { marginBottom: 34 }, Alignment.Horizontal.Left)
			], { paddingRight: 25, proportion: 40 }),
			new ColumnPanel('Overview Right Section', [
				new RowPanel(`Model Overview -  Benchmark}`, [
					this.getHeaderSquare(),
					new ColumnPanel('Benchmark Data', [
						new StaticParagraphComponent('PDF_BENCHMARK_HEADER',
							'Benchmark', {}, { marginBottom: 8 }, ['text-extra-bold', 'text-16']),
						new StaticParagraphComponent(`${this.modelBenchmarkDisclaimer ? this.modelBenchmarkDisclaimer : this.getSlugifiedText(this.aladdinTicker) + '_DISCLOSURE'}`,
							`${this.modelBenchmarkDisclaimer ? this.modelBenchmarkDisclaimer : this.getSlugifiedText(this.aladdinTicker) + '_DISCLOSURE'}`, {}, {}, ['text-9'])
					], {}, Alignment.Horizontal.Left)
				], { marginBottom: 34 }, Alignment.Horizontal.Left)
			], { paddingLeft: 25, proportion: 60 })
		], {}, Alignment.Horizontal.Left, Alignment.Vertical.Top);
		return panel;
	}

	private getHeaderSquare(): ColumnPanel {
		return new ColumnPanel('Square - 4', [
			new SquareRenderer(DZ_COLOR_YELLOW_400, {}, 9, 40)
		], { marginRight: 12, marginTop: 2 }, Alignment.Horizontal.Left);
	}

	private getSlugifiedText(input: string): string {
		const slugifyPipe: SlugifyPipe = new SlugifyPipe();

		return (slugifyPipe.transform(input, '_')).toLocaleUpperCase();
	}
}
